import { getFormValues } from 'redux-form';
import { createSelector } from 'reselect';

import { filterByString } from '@topconagriculture/frontend-utils';

import { trimWhitespace } from '../../../core/helpers/utils/utils';
import { Forms, SearchFormFields } from '../../form/form.selector';
import { RootState } from '../../reducers';
import { Relation } from './relations.types';
import { getLots } from '../lots/lots.selector';
import { Lot } from '../lots/lots.types';

export const getContacts = (state: RootState) => state.entities.relations;

export const getCustomers = (state: RootState) => state.entities.relations.filter((r) => r.isCustomer);

export const getOrderBuyers = (state: RootState) => state.entities.relations.filter((r) => r.isOrderBuyer);

export const getSuppliers = (state: RootState) => state.entities.relations.filter((r) => r.isSupplier);

export const getSupplierById = createSelector(
  [getSuppliers, (state: RootState, id: string): string => id],
  (suppliers: Relation[], id: string) => suppliers.find((supplier) => supplier.id === id),
);

export const getInUseContacts = createSelector(getContacts, (contacts) =>
  contacts.filter((contact) => !contact.notInUse),
);

const relationsFilterFormSelector = getFormValues(Forms.relationSearchForm) as () => SearchFormFields;

export const getCustomerById = createSelector(
  [getCustomers, (_state: RootState, id: string) => id],
  (customers: Relation[], id: string): Relation | undefined => {
    return customers.find((x) => x.id === id);
  },
);

export const getOrderBuyerById = createSelector([getOrderBuyers], (buyers) => (id: string) => {
  return buyers.find((buyer) => buyer.id === id);
});

export const getRelationsListFilteredBySearch = createSelector(
  [getContacts, relationsFilterFormSelector],
  (relations: Relation[], filterFormValues: SearchFormFields) => {
    return filterFormValues
      ? relations.filter((relation) => {
          const searchString = trimWhitespace(filterFormValues.search);
          return filterByString(relation.name, searchString);
        })
      : relations;
  },
);

export const isContactUsed = createSelector(
  [getLots, (_state: RootState, id: string) => id],
  (lots: Lot[], id: string): boolean => {
    return lots.some((lot) => lot.customerId === id || lot.orderBuyerId === id);
  },
);
